











import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast } from "vant";

@Component
export default class Uploading extends Vue {
}
